export default __webpack_public_path__ + "static/media/operating-performance-3.a5556dc0.png";